(function () {
  "use strict";

  var CART_KEY = "mh_custom_cart_v1";
  var EDIT_KEY = "mh_custom_cart_edit_v1";
  var handoffToken = "";

  function clean(value, max) {
    return String(value == null ? "" : value)
      .replace(/[<>\u0000-\u001F\u007F]/g, "")
      .trim()
      .slice(0, max || 2000);
  }

  function parse(value) {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  function uniqueId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return prefix + window.crypto.randomUUID().replace(/-/g, "");
    }
    return prefix + Date.now().toString(36) + Math.random().toString(36).slice(2);
  }

  function ensureLineId(item) {
    var value = item && typeof item === "object" ? item : {};
    if (!/^mhline_[A-Za-z0-9_-]{12,120}$/.test(clean(value.lineId, 140))) {
      value.lineId = uniqueId("mhline_");
    }
    return value;
  }

  function normalizeCart(value) {
    var cart = value && typeof value === "object" && !Array.isArray(value) ? value : {};
    if (!/^mhcart_[A-Za-z0-9_-]{16,120}$/.test(clean(cart.cartId, 140))) {
      cart.cartId = uniqueId("mhcart_");
    }
    cart.schemaVersion = 2;
    cart.items = Array.isArray(cart.items) ? cart.items.filter(function (item) {
      return item && typeof item === "object" && clean(item.submissionId, 200);
    }).map(ensureLineId) : [];
    return cart;
  }

  function readCart() {
    var cart;
    try {
      cart = normalizeCart(parse(localStorage.getItem(CART_KEY) || ""));
      localStorage.setItem(CART_KEY, JSON.stringify(cart));
    } catch (_error) {
      cart = normalizeCart(null);
    }
    return cart;
  }

  function notify(cart) {
    if (typeof window.dispatchEvent !== "function") return;
    try {
      window.dispatchEvent(new CustomEvent("mhcart:change", { detail: { cart: cart } }));
    } catch (_error) {
      // Older browsers still receive the persisted cart on the next render.
    }
  }

  function writeCart(value) {
    var cart = normalizeCart(value);
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    notify(cart);
    return cart;
  }

  function cartHasCheckout(cart) {
    return Boolean(cart && clean(cart.checkoutUrl, 2048));
  }

  function clearEdit() {
    try {
      sessionStorage.removeItem(EDIT_KEY);
    } catch (_error) {
      // The edit query parameter still prevents an unrelated design from replacing a line.
    }
  }

  function startNewCart(previousCartId) {
    var cartId = uniqueId("mhcart_");
    while (cartId === previousCartId) cartId = uniqueId("mhcart_");
    clearEdit();
    return writeCart({ schemaVersion: 2, cartId: cartId, items: [] });
  }

  function removeLine(lineId) {
    var cart = readCart();
    if (cartHasCheckout(cart)) return cart;
    var target = clean(lineId, 140);
    cart.items = cart.items.filter(function (item) { return item.lineId !== target; });
    return writeCart(cart);
  }

  function beginEdit(cart, item) {
    if (!cart || !item || cartHasCheckout(cart)) return false;
    var marker = {
      cartId: clean(cart.cartId, 140),
      lineId: clean(item.lineId, 140),
      savedDesignId: clean(item.savedDesignId, 200),
      originalBuilderReference: clean(item.builderReference, 80).toUpperCase(),
      startedAt: new Date().toISOString(),
    };
    try {
      sessionStorage.setItem(EDIT_KEY, JSON.stringify(marker));
    } catch (_error) {
      return false;
    }
    return marker;
  }

  function activeEditFor(cart) {
    var marker;
    try {
      marker = parse(sessionStorage.getItem(EDIT_KEY) || "");
    } catch (_error) {
      return null;
    }
    if (!marker || marker.cartId !== cart.cartId || !clean(marker.lineId, 140)) return null;
    var queryLine = "";
    try {
      queryLine = clean(new URL(window.location.href).searchParams.get("mh_edit_line"), 140);
    } catch (_error) {
      return null;
    }
    if (queryLine !== marker.lineId) return null;
    var exists = cart.items.some(function (item) { return item.lineId === marker.lineId; });
    return exists ? marker : null;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (character) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character];
    });
  }

  function display(value) {
    if (Array.isArray(value)) return value.filter(Boolean).join(" · ") || "—";
    return clean(value, 2000) || "—";
  }

  function formatColorDisplay(raw) {
    if (!raw || typeof raw !== "string") return raw;
    var capitalizeWord = function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); };
    return raw
      .split("/")
      .map(function (part) { return part.trim().split(" ").filter(Boolean).map(capitalizeWord).join(" "); })
      .join(" / ");
  }

  function decorationMethod(value) {
    var text = clean(value, 2000);
    var methods = [
      [/\bsublimat(?:ed|ion)\s+patch\b/i, "Sublimated Patch"],
      [/\bwoven\s+patch\b/i, "Woven Patch"],
      [/\bembroider(?:ed|y)\s+patch\b/i, "Embroidered Patch"],
      [/\bfaux\s+leather\s+patch\b/i, "Faux Leather Patch"],
      [/\bgenuine\s+leather\s+patch\b/i, "Genuine Leather Patch"],
      [/\bleather\s+patch\b/i, "Leather Patch"],
      [/\bsilicone\s+patch\b/i, "Silicone Patch"],
      [/\b(?:pvc|rubber)\s+patch\b/i, "PVC Patch"],
      [/\bheat\s+transfer\b/i, "Heat Transfer"],
      [/\bscreen\s*print(?:ing)?\b/i, "Screen Printing"],
      [/\bappliqu[eé]\b/i, "Appliqué"],
      [/\bembroider(?:y|ed|ing)?\b|\b[23]d\b/i, "Embroidery"],
      [/\bpatch\b/i, "Patch"],
    ];
    for (var index = 0; index < methods.length; index += 1) {
      if (methods[index][0].test(text)) return methods[index][1];
    }
    return "";
  }

  function decorationLocation(value) {
    var text = clean(value, 2000);
    if (/\bleft(?:\s+side)?\b/i.test(text)) return "Left Side";
    if (/\bright(?:\s+side)?\b/i.test(text)) return "Right Side";
    if (/\bback\b/i.test(text)) return "Back";
    if (/\bfront\b/i.test(text)) return "Front";
    return "";
  }

  function formatDecoration(details, fallback) {
    var values = Array.isArray(details) ? details : clean(details, 2000).split(/[|\n]+/);
    var fallbackMethod = decorationMethod(fallback);
    var byLocation = {};
    var unplacedMethod = "";

    values.forEach(function (value) {
      var location = decorationLocation(value);
      var method = decorationMethod(value) || fallbackMethod;
      if (!method) return;
      if (!location) {
        if (!unplacedMethod || unplacedMethod === "Embroidery") unplacedMethod = method;
        return;
      }
      if (!byLocation[location] || byLocation[location] === "Embroidery") {
        byLocation[location] = method;
      }
    });

    if (!Object.keys(byLocation).length && (unplacedMethod || fallbackMethod)) {
      byLocation.Front = unplacedMethod || fallbackMethod;
    }

    return ["Front", "Left Side", "Right Side", "Back"].filter(function (location) {
      return Boolean(byLocation[location]);
    }).map(function (location) {
      return location + " - " + byLocation[location];
    }).join("\n") || "—";
  }

  function money(value) {
    var raw = clean(value, 80);
    if (!raw) return "—";
    return raw.charAt(0) === "$" ? raw : "$" + raw;
  }

  function updateCount(cart) {
    var count = cart.items.length;
    Array.prototype.forEach.call(document.querySelectorAll("[data-mh-custom-cart-count]"), function (node) {
      node.textContent = count ? "(" + count + ")" : "";
      node.hidden = count === 0;
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-mh-custom-cart-link]"), function (node) {
      node.setAttribute("aria-label", count ? "My Cart, " + count + (count === 1 ? " design" : " designs") : "My Cart, empty");
    });
  }

  function itemHtml(item, frozen) {
    var decoration = formatDecoration(item.decorationDetails, item.decorationType);
    var style = display(item.style);
    var color = display(formatColorDisplay(item.colorName || item.color));
    return '<article class="mh-custom-cart-item" data-mh-cart-line="' + escapeHtml(item.lineId) + '">' +
      '<div class="mh-cart-item-content"><div class="mh-custom-cart-item__head"><div><h2>' + escapeHtml(style + ' · ' + color) + '</h2><p>Design #' + escapeHtml(display(item.builderReference)) + '</p></div>' +
      (!frozen ? '<div class="mh-custom-cart-item__buttons"><button class="mh-text-button" type="button" data-mh-cart-edit="' + escapeHtml(item.lineId) + '">Edit Design</button><button class="mh-text-button mh-text-button--danger" type="button" data-mh-cart-remove="' + escapeHtml(item.lineId) + '">Remove</button></div>' : '') +
      '</div><dl class="mh-custom-cart-details">' +
      '<div class="mh-cart-detail--wide"><dt>Sizes</dt><dd>' + escapeHtml(display(item.sizeBreakdownText || item.sizeBreakdown)) + '</dd></div>' +
      '<div class="mh-cart-detail--wide"><dt>Decoration</dt><dd>' + escapeHtml(decoration) + '</dd></div>' +
      '<div><dt>Total hats</dt><dd>' + escapeHtml(display(item.quantity)) + '</dd></div>' +
      '<div><dt>Price per hat</dt><dd>' + escapeHtml(money(item.unitPrice || item.customerUnitPrice)) + '</dd></div>' +
      '<div class="mh-cart-line-total"><dt>Design total</dt><dd>' + escapeHtml(money(item.merchandiseTotal || item.customerTotal)) + '</dd></div>' +
      '</dl></div></article>';
  }

  function moneyValue(value) {
    var amount = Number(clean(value, 80).replace(/[$,]/g, ""));
    return Number.isFinite(amount) && amount > 0 ? amount : 0;
  }

  function cartOverviewHtml(cart) {
    var hats = cart.items.reduce(function (sum, item) {
      var quantity = Number(item.quantity);
      return sum + (Number.isFinite(quantity) && quantity > 0 ? quantity : 0);
    }, 0);
    var total = cart.items.reduce(function (sum, item) {
      return sum + moneyValue(item.merchandiseTotal || item.customerTotal);
    }, 0);
    return '<div><span>DESIGN(S)</span><strong>' + cart.items.length + '</strong></div>' +
      '<div><span>Total hats</span><strong>' + hats + '</strong></div>' +
      '<div class="mh-cart-overview__total"><span>Order total</span><strong>' + (total ? '$' + total.toFixed(2) : '—') + '</strong></div>';
  }

  function renderCartView(cart) {
    var view = document.querySelector("[data-mh-custom-cart-view]");
    if (!view) return;
    var itemsNode = view.querySelector("[data-mh-custom-cart-items]");
    var emptyNode = view.querySelector("[data-mh-custom-cart-empty]");
    var overviewNode = view.querySelector("[data-mh-cart-overview]");
    var actionsNode = view.querySelector("[data-mh-custom-cart-actions]");
    var statusNode = view.querySelector("[data-mh-custom-cart-status]");
    var frozen = cartHasCheckout(cart);
    if (itemsNode) itemsNode.innerHTML = cart.items.map(function (item) { return itemHtml(item, frozen); }).join("");
    if (emptyNode) emptyNode.hidden = cart.items.length > 0;
    if (overviewNode) {
      overviewNode.hidden = !cart.items.length;
      overviewNode.innerHTML = cart.items.length ? cartOverviewHtml(cart) : "";
    }
    if (actionsNode) {
      if (!cart.items.length) {
        actionsNode.innerHTML = '<a class="mh-button" href="' + escapeHtml(view.dataset.builderUrl || "/pages/custom-hat-builder") + '">Start Designing</a>';
      } else if (frozen) {
        actionsNode.innerHTML = '<button class="mh-button" type="button" data-mh-cart-checkout>Return to Checkout</button><button class="mh-button mh-button--secondary" type="button" data-mh-cart-new>Start New Order</button>';
      } else {
        actionsNode.innerHTML = '<button class="mh-button" type="button" data-mh-cart-checkout>Proceed to Checkout</button><a class="mh-button mh-button--secondary" href="' + escapeHtml(view.dataset.builderUrl || "/pages/custom-hat-builder") + '">Add Another Design</a>';
      }
    }
    if (statusNode && frozen) {
      statusNode.hidden = false;
      statusNode.dataset.state = "success";
      statusNode.textContent = "This order is ready at checkout.";
    } else if (statusNode && statusNode.dataset.state !== "error" && statusNode.dataset.state !== "loading") {
      statusNode.hidden = true;
      statusNode.textContent = "";
    }
  }

  function responseJson(response) {
    return response.text().then(function (raw) {
      var data = parse(raw);
      if (!data) throw new Error("Checkout returned an unreadable response.");
      if (!response.ok || data.success === false) {
        var error = new Error(data.message || "Unable to prepare checkout.");
        error.code = clean(data.code, 120);
        throw error;
      }
      return data;
    });
  }

  function postWithToken(endpoint, mode, payload, token) {
    var requestUrl = new URL(endpoint, window.location.origin);
    requestUrl.searchParams.set("mh_mode", mode);
    return fetch(requestUrl.pathname + requestUrl.search, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(Object.assign({}, payload, { mode: mode, handoffToken: token })),
    }).then(responseJson);
  }

  function post(endpoint, mode, payload) {
    if (handoffToken) return postWithToken(endpoint, mode, payload, handoffToken);
    return fetch(endpoint, { method: "GET", credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(responseJson)
      .then(function (token) {
        handoffToken = clean(token.handoffToken, 2048);
        if (!handoffToken) throw new Error("Unable to start secure checkout.");
        return postWithToken(endpoint, mode, payload, handoffToken);
      });
  }

  function checkoutCart(options) {
    options = options || {};
    var cart = readCart();
    var endpoint = clean(options.endpoint || "/apps/momentec-checkout", 500);
    var statusNode = options.statusNode || null;
    if (!cart.items.length) return Promise.reject(new Error("Your custom cart is empty."));
    if (statusNode) {
      statusNode.hidden = false;
      statusNode.dataset.state = "loading";
      statusNode.textContent = cartHasCheckout(cart) ? "Returning to secure checkout…" : "Preparing secure checkout…";
    }
    return post(endpoint, "checkout_cart", {
      cartId: cart.cartId,
      submissionIds: cart.items.map(function (item) { return item.submissionId; }),
    }).then(function (data) {
      if (!data.checkoutUrl) throw new Error("Shopify did not return a checkout link.");
      cart.checkoutUrl = clean(data.checkoutUrl, 2048);
      cart.checkedOutAt = cart.checkedOutAt || new Date().toISOString();
      writeCart(cart);
      renderCartView(cart);
      window.location.assign(cart.checkoutUrl);
      return data;
    }).catch(function (error) {
      if (statusNode) {
        statusNode.hidden = false;
        statusNode.dataset.state = "error";
        statusNode.textContent = error.message || "Unable to prepare checkout.";
      }
      throw error;
    });
  }

  function renderAll() {
    var cart = readCart();
    updateCount(cart);
    renderCartView(cart);
  }

  function onCartClick(event) {
    var view = event.target && event.target.closest ? event.target.closest("[data-mh-custom-cart-view]") : null;
    if (!view) return;
    var remove = event.target.closest("[data-mh-cart-remove]");
    var edit = event.target.closest("[data-mh-cart-edit]");
    var checkout = event.target.closest("[data-mh-cart-checkout]");
    var newOrder = event.target.closest("[data-mh-cart-new]");
    if (!remove && !edit && !checkout && !newOrder) return;
    event.preventDefault();
    var cart = readCart();

    if (remove && !cartHasCheckout(cart)) {
      var removeId = clean(remove.getAttribute("data-mh-cart-remove"), 140);
      removeLine(removeId);
      renderAll();
      return;
    }

    if (edit && !cartHasCheckout(cart)) {
      var editId = clean(edit.getAttribute("data-mh-cart-edit"), 140);
      var item = cart.items.filter(function (candidate) { return candidate.lineId === editId; })[0];
      var marker = beginEdit(cart, item);
      if (!marker) return;
      var editUrl = new URL(view.dataset.builderUrl || "/pages/custom-hat-builder", window.location.origin);
      editUrl.searchParams.set("dNumber", marker.originalBuilderReference.replace(/^C/i, ""));
      editUrl.searchParams.set("mh_edit_line", marker.lineId);
      window.location.assign(editUrl.pathname + editUrl.search);
      return;
    }

    if (newOrder) {
      startNewCart(cart.cartId);
      window.location.assign(view.dataset.builderUrl || "/pages/custom-hat-builder");
      return;
    }

    if (checkout) {
      checkout.disabled = true;
      checkoutCart({ endpoint: view.dataset.appEndpoint, statusNode: view.querySelector("[data-mh-custom-cart-status]") })
        .catch(function () { checkout.disabled = false; });
    }
  }

  window.MomentecCustomCart = {
    CART_KEY: CART_KEY,
    EDIT_KEY: EDIT_KEY,
    read: readCart,
    write: writeCart,
    hasCheckout: cartHasCheckout,
    startNew: startNewCart,
    remove: removeLine,
    ensureLineId: ensureLineId,
    activeEditFor: activeEditFor,
    clearEdit: clearEdit,
    formatDecoration: formatDecoration,
    checkout: checkoutCart,
    render: renderAll,
  };

  document.addEventListener("click", onCartClick, true);
  window.addEventListener("mhcart:change", renderAll);
  window.addEventListener("pageshow", renderAll);
  renderAll();
})();
